module.exports = __webpack_public_path__ + "img/4_174.aea1bcf5.png";